import { atomWithRefresh } from "jotai/utils";

export const $now = atomWithRefresh(() => new Date());

// Exclude from devtools
$now.debugPrivate = true;

$now.onMount = (set) => {
	const interval = setInterval(() => {
		set();
	}, 1000); // 1 second

	return () => clearInterval(interval);
};
